// Shared display formatters for audit columns (Created By / Created On /
// Updated By / Updated On) used by SourceInfo.js and StaffDetails.js.

const capitalize = (part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();

// Azure AD usernames follow the "lastname.firstname@tenant" convention, e.g.
// nallareddy.pranesh@sathyaseelanmhisworld.onmicrosoft.com -> "Pranesh Nallareddy".
// The first dot-separated part is the last name and is moved to the end; any
// value that doesn't fit the pattern degrades gracefully instead of throwing.
export const formatUserName = (value) => {
  if (typeof value !== 'string' || !value.trim()) return '-';
  const userName = value.trim().split('@')[0];
  const parts = userName.split('.').filter(Boolean);
  if (parts.length === 0) return value.trim();
  const [lastName, ...firstNames] = parts;
  return [...firstNames, lastName].map(capitalize).join(' ');
};

// e.g. 2026-09-24T14:07:58 -> "24/9/2026, 2:07:58 pm". The backend sends IST
// wall-clock values without an offset, so they're parsed and shown as-is.
export const formatDate = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '-' : date.toLocaleString('en-IN');
};
